/**
 * haptics.js — utility do wibracji na key interactions (premium "physical" feeling).
 * Działa na Android Chrome + iOS PWA (Safari ignoruje vibrate w przeglądarce — nie ma fallbacka).
 *
 * Patterns:
 *  - tap(): krótka 10ms wibracja przy każdym tapnięciu (button, select)
 *  - select(): 15ms na wybór opcji (topic, version)
 *  - success(): 25ms na akcję sukcesu (publish, save)
 *  - error(): 50ms na błąd
 *  - heavy(): 30ms na najważniejsze akcje (final publish)
 */

const isSupported = () => typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function';

function safe(ms) {
  if (!isSupported()) return;
  try {
    navigator.vibrate(ms);
  } catch {
    // ignore
  }
}

export const haptics = {
  tap: () => safe(10),
  select: () => safe(15),
  success: () => safe(25),
  error: () => safe(50),
  heavy: () => safe(30),
};

export default haptics;
